import React from 'react';
import { 
  Zap, 
  MessageCircle, 
  Clock, 
  GitBranch, 
  Square,
  ShoppingCart,
  Package,
  Truck,
  UserPlus,
  Mail,
  Phone,
  Bell,
  MapPin,
  Database,
  MessageSquare,
  CreditCard,
  CheckCircle,
  XCircle,
  RotateCcw,
  Tag,
  TagIcon,
  Ban,
  Wallet,
  Hash,
  StickyNote,
  Webhook,
  ClipboardList,
  DollarSign,
} from 'lucide-react';

const nodeCategories = [
  {
    title: 'Triggers',
    description: 'Start your journey',
    nodes: [
      {
        type: 'trigger',
        label: 'Checkout Abandoned',
        icon: ShoppingCart,
        color: 'green',
        data: { trigger_type: 'checkout_abandoned', label: 'Checkout Abandoned' },
      },
      {
        type: 'trigger',
        label: 'Order Created',
        icon: Package,
        color: 'green',
        data: { trigger_type: 'order_created', label: 'Order Created' },
      },
      {
        type: 'trigger',
        label: 'Ready For Dispatch',
        icon: Package,
        color: 'cyan',
        data: { trigger_type: 'order_ready_for_dispatch', label: 'Ready For Dispatch' },
      },
      {
        type: 'trigger',
        label: 'Out for Delivery',
        icon: Truck,
        color: 'blue',
        data: { trigger_type: 'order_out_for_delivery', label: 'Out for Delivery' },
      },
      {
        type: 'trigger',
        label: 'Order Delivered',
        icon: Truck,
        color: 'green',
        data: { trigger_type: 'order_delivered', label: 'Order Delivered' },
      },
      {
        type: 'trigger',
        label: 'Production Started',
        icon: Package,
        color: 'amber',
        data: { trigger_type: 'production_started', label: 'Production Started' },
      },
      {
        type: 'trigger',
        label: 'Production ETA Updated',
        icon: Clock,
        color: 'amber',
        data: { trigger_type: 'production_eta_updated', label: 'Production ETA Updated' },
      },
      {
        type: 'trigger',
        label: 'Production Completed',
        icon: CheckCircle,
        color: 'green',
        data: { trigger_type: 'production_completed', label: 'Production Completed' },
      },
      {
        type: 'trigger',
        label: 'Order Paid',
        icon: Package,
        color: 'green',
        data: { trigger_type: 'order_paid', label: 'Order Paid' },
      },
      {
        type: 'trigger',
        label: 'Order Fulfilled',
        icon: Package,
        color: 'purple',
        data: { trigger_type: 'order_fulfilled', label: 'Order Fulfilled' },
      },
      {
        type: 'trigger',
        label: 'Order Shipped',
        icon: Truck,
        color: 'indigo',
        data: { trigger_type: 'order_shipped', label: 'Order Shipped' },
      },
      {
        type: 'trigger',
        label: 'AWB Generated',
        icon: Truck,
        color: 'cyan',
        data: { trigger_type: 'awb_generated', label: 'AWB Generated' },
      },
      {
        type: 'trigger',
        label: 'Order Cancelled',
        icon: XCircle,
        color: 'red',
        data: { trigger_type: 'order_cancelled', label: 'Order Cancelled' },
      },
      {
        type: 'trigger',
        label: 'Order Refunded',
        icon: RotateCcw,
        color: 'red',
        data: { trigger_type: 'order_refunded', label: 'Order Refunded' },
      },
      {
        type: 'trigger',
        label: 'Payment Received',
        icon: CreditCard,
        color: 'green',
        data: { trigger_type: 'payment_received', label: 'Payment Received' },
      },
      {
        type: 'trigger',
        label: 'Payment Failed',
        icon: CreditCard,
        color: 'red',
        data: { trigger_type: 'payment_failed', label: 'Payment Failed' },
      },
      {
        type: 'trigger',
        label: 'Customer Created',
        icon: UserPlus,
        color: 'green',
        data: { trigger_type: 'customer_created', label: 'Customer Created' },
      },
      {
        type: 'trigger',
        label: 'Lead Created',
        icon: UserPlus,
        color: 'green',
        data: { trigger_type: 'lead_created', label: 'Lead Created' },
      },
      // Store Credits Triggers
      {
        type: 'trigger',
        label: 'Credits Added',
        icon: CreditCard,
        color: 'purple',
        data: { trigger_type: 'credits_added', label: 'Credits Added' },
      },
      {
        type: 'trigger',
        label: 'Credits Expiring',
        icon: Clock,
        color: 'yellow',
        data: { trigger_type: 'credits_expiring', label: 'Credits Expiring' },
      },
      {
        type: 'trigger',
        label: 'Credits Expired',
        icon: Clock,
        color: 'red',
        data: { trigger_type: 'credits_expired', label: 'Credits Expired' },
      },
      {
        type: 'trigger',
        label: 'Courier Assigned',
        icon: Truck,
        color: 'blue',
        data: { trigger_type: 'courier_assigned', label: 'Courier Assigned' },
      },
      {
        type: 'trigger',
        label: 'Courier Picked Up',
        icon: Package,
        color: 'blue',
        data: { trigger_type: 'courier_picked_up', label: 'Courier Picked Up' },
      },
      {
        type: 'trigger',
        label: 'Courier In Transit',
        icon: Truck,
        color: 'amber',
        data: { trigger_type: 'courier_in_transit', label: 'Courier In Transit' },
      },
      {
        type: 'trigger',
        label: 'Courier Delivered',
        icon: CheckCircle,
        color: 'green',
        data: { trigger_type: 'courier_delivered', label: 'Courier Delivered' },
      },
      {
        type: 'trigger',
        label: 'Failed Delivery Attempt (NDR)',
        icon: XCircle,
        color: 'red',
        data: { trigger_type: 'courier_failed', label: 'Failed Delivery Attempt (NDR)' },
      },
      {
        type: 'trigger',
        label: 'Delivery Rescheduled',
        icon: Clock,
        color: 'orange',
        data: { trigger_type: 'order_delivery_rescheduled', label: 'Delivery Rescheduled' },
      },
      {
        type: 'trigger',
        label: 'Return Accepted',
        icon: RotateCcw,
        color: 'teal',
        data: { trigger_type: 'return_accepted', label: 'Return Accepted' },
      },
      {
        type: 'trigger',
        label: 'Return Picked Up',
        icon: Package,
        color: 'teal',
        data: { trigger_type: 'return_picked_up', label: 'Return Picked Up' },
      },
      {
        type: 'trigger',
        label: 'Return QC Completed',
        icon: CheckCircle,
        color: 'green',
        data: { trigger_type: 'return_qc_completed', label: 'Return QC Completed' },
      },
      {
        type: 'trigger',
        label: 'Refund Issued',
        icon: DollarSign,
        color: 'green',
        data: { trigger_type: 'return_refund_issued', label: 'Refund Issued' },
      },
      {
        type: 'trigger',
        label: 'RTO (Return to Origin)',
        icon: RotateCcw,
        color: 'orange',
        data: { trigger_type: 'courier_rto', label: 'RTO (Return to Origin)' },
      },
      {
        type: 'trigger',
        label: 'Manual Entry',
        icon: Zap,
        color: 'green',
        data: { trigger_type: 'manual', label: 'Manual Entry' },
      },
      // Marketplace Vendor — Purchase Order lifecycle (Phase 3)
      {
        type: 'trigger',
        label: 'MP PO · Created',
        icon: Package,
        color: 'amber',
        data: { trigger_type: 'marketplace_po_created', label: 'MP PO · Created' },
      },
      {
        type: 'trigger',
        label: 'MP PO · Accepted',
        icon: Package,
        color: 'blue',
        data: { trigger_type: 'marketplace_po_accepted', label: 'MP PO · Accepted by vendor' },
      },
      {
        type: 'trigger',
        label: 'MP PO · Rejected',
        icon: XCircle,
        color: 'red',
        data: { trigger_type: 'marketplace_po_rejected', label: 'MP PO · Rejected by vendor' },
      },
      {
        type: 'trigger',
        label: 'MP PO · Ready for pickup',
        icon: Package,
        color: 'cyan',
        data: { trigger_type: 'marketplace_po_ready_for_pickup', label: 'MP PO · Ready for pickup' },
      },
      {
        type: 'trigger',
        label: 'MP PO · Picked up',
        icon: Package,
        color: 'indigo',
        data: { trigger_type: 'marketplace_po_picked_up', label: 'MP PO · Picked up by courier' },
      },
      {
        type: 'trigger',
        label: 'MP PO · Delivered',
        icon: Package,
        color: 'green',
        data: { trigger_type: 'marketplace_po_delivered', label: 'MP PO · Delivered' },
      },
      // Marketplace Vendor Payouts (Phase 4)
      {
        type: 'trigger',
        label: 'MP Payout · Submitted',
        icon: Package,
        color: 'amber',
        data: { trigger_type: 'marketplace_payout_submitted', label: 'MP Payout · Submitted' },
      },
      {
        type: 'trigger',
        label: 'MP Payout · Approved',
        icon: Package,
        color: 'blue',
        data: { trigger_type: 'marketplace_payout_approved', label: 'MP Payout · Approved' },
      },
      {
        type: 'trigger',
        label: 'MP Payout · Paid',
        icon: Package,
        color: 'green',
        data: { trigger_type: 'marketplace_payout_paid', label: 'MP Payout · Paid' },
      },
      {
        type: 'trigger',
        label: 'MP Payout · Rejected',
        icon: XCircle,
        color: 'red',
        data: { trigger_type: 'marketplace_payout_rejected', label: 'MP Payout · Rejected' },
      },
    ],
  },
  {
    title: 'Actions',
    description: 'Send messages',
    nodes: [
      {
        type: 'action',
        label: 'Send WhatsApp',
        icon: MessageCircle,
        color: 'amber',
        data: { action_type: 'whatsapp', label: 'Send WhatsApp' },
      },
      {
        type: 'action',
        label: 'Send Email',
        icon: Mail,
        color: 'amber',
        data: { action_type: 'email', label: 'Send Email' },
      },
      {
        type: 'action',
        label: 'Send SMS',
        icon: Phone,
        color: 'amber',
        data: { action_type: 'sms', label: 'Send SMS' },
        disabled: true,
        comingSoon: true,
      },
      {
        type: 'action',
        label: 'Send Push',
        icon: Bell,
        color: 'amber',
        data: {
          action_type: 'push',
          push_title: '',
          push_body: '',
          push_cta_url: '',
          push_cta_label: 'View',
          label: 'Send Push',
        },
      },
      {
        type: 'action',
        label: 'Add Tag',
        icon: Tag,
        color: 'teal',
        data: { action_type: 'add_tag', tag_value: '', sync_to_shopify: true, label: 'Add Tag' },
      },
      {
        type: 'action',
        label: 'Remove Tag',
        icon: TagIcon,
        color: 'teal',
        data: { action_type: 'remove_tag', tag_value: '', sync_to_shopify: true, label: 'Remove Tag' },
      },
      {
        type: 'action',
        label: 'Cancel Order',
        icon: Ban,
        color: 'red',
        data: { action_type: 'cancel_order', cancel_reason: 'customer', restock: true, notify_customer: false, sync_to_shopify: true, label: 'Cancel Order' },
      },
      {
        type: 'action',
        label: 'Add Store Credit',
        icon: CreditCard,
        color: 'purple',
        data: { action_type: 'add_store_credit', credit_amount: 100, credit_expires_in_days: 90, credit_reason: '', label: 'Add Store Credit' },
      },
      {
        type: 'action',
        label: 'Deduct Store Credit',
        icon: Wallet,
        color: 'purple',
        data: { action_type: 'remove_store_credit', credit_amount: 100, credit_reason: '', label: 'Deduct Store Credit' },
      },
      {
        type: 'action',
        label: 'Customer Tag',
        icon: Hash,
        color: 'teal',
        data: { action_type: 'update_customer_tag', tag_value: '', tag_op: 'add', label: 'Customer Tag' },
      },
      {
        type: 'action',
        label: 'Order Note',
        icon: StickyNote,
        color: 'amber',
        data: { action_type: 'update_order_note', note_text: '', append: true, label: 'Order Note' },
      },
      {
        type: 'action',
        label: 'HTTP Webhook',
        icon: Webhook,
        color: 'blue',
        data: { action_type: 'http_webhook', webhook_url: '', webhook_method: 'POST', webhook_headers: {}, webhook_body: '', label: 'HTTP Webhook' },
      },
      {
        type: 'action',
        label: 'Create Task',
        icon: ClipboardList,
        color: 'green',
        data: { action_type: 'create_task', task_title: '', task_description: '', assignee_id: '', priority: 'medium', label: 'Create Task' },
      },
      {
        type: 'action',
        label: 'Send to Slack',
        icon: MessageSquare,
        color: 'purple',
        data: { action_type: 'send_slack', webhook_url: '', message: '', label: 'Send to Slack' },
      },
      {
        type: 'action',
        label: 'Send to Discord',
        icon: MessageSquare,
        color: 'purple',
        data: { action_type: 'send_discord', webhook_url: '', message: '', label: 'Send to Discord' },
      },
    ],
  },
  {
    title: 'Flow Control',
    description: 'Control the flow',
    nodes: [
      {
        type: 'delay',
        label: 'Delay',
        icon: Clock,
        color: 'blue',
        data: { delay_value: 1, delay_unit: 'hours', label: 'Wait' },
      },
      {
        type: 'condition',
        label: 'Condition',
        icon: GitBranch,
        color: 'purple',
        data: { 
          condition_field: 'order.total', 
          condition_operator: '>', 
          condition_value: '100',
          label: 'If / Else' 
        },
      },
      {
        type: 'wait_for_response',
        label: 'Wait for Response',
        icon: MessageSquare,
        color: 'cyan',
        data: { 
          response_type: 'location',
          timeout_hours: 24,
          label: 'Wait for Location' 
        },
      },
      {
        type: 'button_router',
        label: 'Button Router',
        icon: GitBranch,
        color: 'purple',
        data: {
          timeout_hours: 24,
          buttons: [],
          label: 'Route by Button Reply',
        },
      },
      {
        type: 'update_data',
        label: 'Update Data',
        icon: Database,
        color: 'teal',
        data: { 
          target_entity: 'order',
          target_field: 'delivery_location',
          source_field: 'response.location',
          label: 'Save Location to Order' 
        },
      },
      {
        type: 'end',
        label: 'End Journey',
        icon: Square,
        color: 'red',
        data: { label: 'End Journey' },
      },
    ],
  },
];

const colorClasses = {
  green: {
    bg: 'bg-green-500/10 hover:bg-green-500/20',
    border: 'border-green-500/30',
    icon: 'text-green-400',
  },
  amber: {
    bg: 'bg-amber-500/10 hover:bg-amber-500/20',
    border: 'border-amber-500/30',
    icon: 'text-wt-gold',
  },
  blue: {
    bg: 'bg-blue-500/10 hover:bg-blue-500/20',
    border: 'border-blue-500/30',
    icon: 'text-blue-400',
  },
  purple: {
    bg: 'bg-purple-500/10 hover:bg-purple-500/20',
    border: 'border-purple-500/30',
    icon: 'text-purple-400',
  },
  red: {
    bg: 'bg-red-500/10 hover:bg-red-500/20',
    border: 'border-red-500/30',
    icon: 'text-red-400',
  },
  cyan: {
    bg: 'bg-cyan-500/10 hover:bg-cyan-500/20',
    border: 'border-cyan-500/30',
    icon: 'text-cyan-400',
  },
  teal: {
    bg: 'bg-teal-500/10 hover:bg-teal-500/20',
    border: 'border-teal-500/30',
    icon: 'text-teal-400',
  },
};

function DraggableNode({ node }) {
  const colors = colorClasses[node.color] || colorClasses.amber;
  const Icon = node.icon;

  const onDragStart = (event) => {
    event.dataTransfer.setData('application/reactflow/type', node.type);
    event.dataTransfer.setData('application/reactflow/data', JSON.stringify(node.data));
    event.dataTransfer.effectAllowed = 'move';
  };

  if (node.disabled) {
    return (
      <div
        className={`
          relative p-3 rounded-lg border cursor-not-allowed
          bg-wt-surface/50 border-wt-border opacity-50
        `}
      >
        <div className="flex items-center gap-2">
          <div className="p-1.5 rounded bg-wt-bg">
            <Icon className="h-4 w-4 text-wt-text-muted" />
          </div>
          <div>
            <div className="text-sm font-medium text-wt-text-muted">{node.label}</div>
            {node.comingSoon && (
              <div className="text-[10px] text-wt-text-muted">Coming Soon</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      draggable
      onDragStart={onDragStart}
      className={`
        p-3 rounded-lg border cursor-grab active:cursor-grabbing
        ${colors.bg} ${colors.border}
        transition-all duration-200 hover:scale-[1.02]
      `}
    >
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded ${colors.bg}`}>
          <Icon className={`h-4 w-4 ${colors.icon}`} />
        </div>
        <span className="text-sm font-medium text-wt-text-primary">{node.label}</span>
      </div>
    </div>
  );
}

export function NodePalette() {
  return (
    <div className="w-64 h-full bg-wt-surface border-r border-wt-border overflow-y-auto">
      <div className="p-4">
        <h3 className="text-lg font-semibold text-wt-text-primary mb-1">
          Node Palette
        </h3>
        <p className="text-xs text-wt-text-muted mb-4">
          Drag nodes onto the canvas
        </p>
        
        {nodeCategories.map((category) => (
          <div key={category.title} className="mb-6">
            <div className="mb-2">
              <h4 className="text-sm font-medium text-wt-text-primary">
                {category.title}
              </h4>
              <p className="text-xs text-wt-text-muted">{category.description}</p>
            </div>
            <div className="space-y-2">
              {category.nodes.map((node) => (
                <DraggableNode key={`${node.type}-${node.label}`} node={node} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NodePalette;
